import { addToChainAfter, addToChainBefore, ApiHandlerDiscreteParameter, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import {
    FulfillmentMethod,
    Session,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import {
    chain,
    LoadCart,
} from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import setFulfillmentMethod from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";

import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { ThosSetDefaultWarehouse } from "@thos/Services/ThosWarehouseService";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        fulfillmentMethod: "Ship" | "PickUp";
        pickUpWarehouse?: WarehouseModel;
    } & HasOnComplete<void>,
    UpdateSessionApiParameter,
    Session
>;

export const UpdateWarehouse: HandlerType = async props => {
    
    if (props.parameter.pickUpWarehouse && props.parameter.fulfillmentMethod === FulfillmentMethod.Ship) {
        await ThosSetDefaultWarehouse(props.parameter.pickUpWarehouse);
        props.dispatch(loadSession());
    }
};
addToChainBefore(chain, LoadCart, UpdateWarehouse);
